import * as React from 'react'

function DoubleCheckedIcon(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg width={84} height={84} fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M18.441 13.605C20.223 6.46 27.46 2.112 34.604 3.894l35.578 8.87c7.145 1.782 11.493 9.018 9.711 16.163l-8.87 35.577c-1.781 7.145-9.018 11.494-16.163 9.712l-35.578-8.87c-7.145-1.782-11.493-9.018-9.711-16.163l8.87-35.578z'
        fill='url(#prefix__paint0_linear_3755_8830)'
      />
      <g filter='url(#prefix__filter0_bi_3755_8830)'>
        <path
          d='M0 34.001c0-7.363 5.97-13.333 13.333-13.333H50c7.364 0 13.333 5.97 13.333 13.333v36.667c0 7.364-5.97 13.333-13.333 13.333H13.333C5.97 84.001 0 78.031 0 70.668V34.001z'
          fill='url(#prefix__paint1_linear_3755_8830)'
          fillOpacity={0.5}
        />
      </g>
      <path
        d='M28.1 61.865a2.622 2.622 0 01-1.862-.77l-7.134-7.134a2.628 2.628 0 010-3.719 2.627 2.627 0 013.719-.003l5.276 5.277 12.41-12.41a2.631 2.631 0 013.719 3.722L29.96 61.094a2.622 2.622 0 01-1.86.77'
        fill='#fff'
      />
      <defs>
        <linearGradient
          id='prefix__paint0_linear_3755_8830'
          x1={83.119}
          y1={15.99}
          x2={10.821}
          y2={68.306}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#00D82F' />
          <stop offset={1} stopColor='#2FA7CD' />
        </linearGradient>
        <linearGradient
          id='prefix__paint1_linear_3755_8830'
          x1={-3.297}
          y1={89.279}
          x2={86.972}
          y2={64.212}
          gradientUnits='userSpaceOnUse'
        >
          <stop stopColor='#45CAF4' />
          <stop offset={1} stopColor='#00D82F' />
        </linearGradient>
        <filter
          id='prefix__filter0_bi_3755_8830'
          x={-8.889}
          y={11.779}
          width={81.111}
          height={81.112}
          filterUnits='userSpaceOnUse'
          colorInterpolationFilters='sRGB'
        >
          <feFlood floodOpacity={0} result='BackgroundImageFix' />
          <feGaussianBlur in='BackgroundImageFix' stdDeviation={4.444} />
          <feComposite in2='SourceAlpha' operator='in' result='effect1_backgroundBlur_3755_8830' />
          <feBlend in='SourceGraphic' in2='effect1_backgroundBlur_3755_8830' result='shape' />
          <feColorMatrix in='SourceAlpha' values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0' result='hardAlpha' />
          <feOffset dx={0.444} dy={0.222} />
          <feGaussianBlur stdDeviation={1.111} />
          <feComposite in2='hardAlpha' operator='arithmetic' k2={-1} k3={1} />
          <feColorMatrix values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.6 0' />
          <feBlend in2='shape' result='effect2_innerShadow_3755_8830' />
        </filter>
      </defs>
    </svg>
  )
}

export default DoubleCheckedIcon
